// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f18c4333","239":"a704134e","488":"33b4f7d6","732":"8a793c55"}[chunkId] + ".chunk.js";
};